import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import withWidth from '@material-ui/core/withWidth';
import { Link } from 'react-router-dom';
import numeral from 'numeral';
import getSymbolFromCurrency from 'currency-symbol-map';
import { RegisterOrLoginToSeePriceNotice } from './../../DiamondDetails';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import stylesMobile from './styles-mobile.module.scss';
import classNames from "classnames";
import { convertToCurrency } from 'shared/functions/priceCalc';

const MeasurementsTextShorter = ({ row }) => [row.StkMes1, row.StkMes2, row.StkMes3].map(s => s && `${s}` || '-').join(' x ') + ' mm';
const MeasurementsText = ({ row }) => [row.StkMes1, row.StkMes2, row.StkMes3].map(s => s && `${s}mm` || '-').join(' x ');
const Measurements = ({ row }) => <td><b>Measurements:</b> <MeasurementsText row={row} /></td>;

export const DiamondDetailsList = ({ isParcel, row, isAuthorised, fxrates=[], ccy, className }) => {
    return <React.Fragment>
        {!isParcel && <div className={className}>
            <div>
                <span>Code</span>
                <span>{row.StkCodeCalcNS || '-'}</span>
            </div>
            <div>
                <span>Shape</span>
                <span>{row.StkShape || '-'}</span>
            </div>
            <div>
                <span>Clarity</span>
                <span>{row.clarity || '-'}</span>
            </div>
            <div>
                <span>Fluorescence</span>
                <span>{row.flourecence || '-'}</span>
            </div>
            <div>
                <span>Colour</span>
                <span>{row.colour || '-'}</span>
            </div>
            <div>
                <span>Table</span>
                <span>{row.StkTable ? row.StkTable + '%' : '-'}</span>
            </div>
            <div>
                <span>LAB</span>
                <span>{row.StkCertSup || '-'}</span>
            </div>
            <div>
                <span>Certificate</span>
                <span>{row.StkCertNo || '-'}</span>
            </div>
            <div>
                <span>Weight</span>
                <span>{numeral(row.STWeight).format('0.00') + 'ct'}</span>
            </div>
            <div>
                <span>Cut</span>
                <span>{row.cut || '-'}</span>
            </div>
            <div>
                <span>Symmetry</span>
                <span>{row.symmetry || '-'}</span>
            </div>
            <div>
                <span>Polish</span>
                <span>{row.polish || '-'}</span>
            </div>
            {isAuthorised && <div>
                <span>RAP</span>
                <span>{row.RAP ? row.RAP + '%' : '-'}</span>
            </div>}
            <div>
                <span>Measurements</span>
                <span><MeasurementsTextShorter row={row} /></span>
            </div>
            {isAuthorised && <div>
                <span>Price per carat</span>
                <span>{row.ppcOrig ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.priceOrig, false, fxrates, ccy)) / parseFloat(row.STWeight)).format('0,0.00')}</React.Fragment> : '-'}</span>
            </div>}
            {isAuthorised && <div>
                <span>RAP Below</span>
                <span>{row.RAP ? row.RAP + '%' : '-'}</span>
            </div>}
            {isAuthorised && <div>
                <span>Price</span>
                <span>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.priceOrig, false, fxrates, ccy))).format('0,0.00')}</span>
            </div>}
            {isAuthorised && row.WebSpecial && <div>
                <span>Special Price</span>
                <span>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00')}</span>
            </div>}
        </div>}

        {isParcel && <div className={className}>
            <div>
                <span>Code</span>
                <span>{row.StkCodeCalcNS || '-'}</span>
            </div>
            <div>
                <span>Shape</span>
                <span>{row.StkShape || '-'}</span>
            </div>
            <div>
                <span>Colour</span>
                <span>{row.colour || '-'}</span>
            </div>
            <div>
                <span>Clarity</span>
                <span>{row.clarity || '-'}</span>
            </div>
            <div>
                <span>Measurements</span>
                <span><MeasurementsTextShorter row={row} /></span>
            </div>
            <div>
                <span>Weight</span>
                <span>{row.size || '-'}</span>
            </div>
            <div>
                <span>Sieve Plate</span>
                <span>{row.sieve || '-'}</span>
            </div>
            <div>
                <span>Comments</span>
                <span>{row.Comments || '-'}</span>
            </div>
            {isAuthorised && <div>
                <span>Price per carat</span>
                <span>{row.ppcOrig ? getSymbolFromCurrency(ccy) + numeral(Math.round(convertToCurrency(row.ppcOrig, true, fxrates, ccy))).format('0,0.00') : '-'}</span>
            </div>}
            {isAuthorised && row.WebSpecial ? <div>
                <span>Special Price</span>
                <span>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.WebSpecial, true, fxrates, ccy))).format('0,0.00')}</span>
            </div> : ''}
        </div>}
    </React.Fragment>
}


const DiamondRowDetails = styled(({ className, isParcel, row, isAuthorised, ccy, fxrates = [], open360MessageDialog, openEmailDialog, setOpen, toggleCompare, isCompare, toggleFav, isFav, ...props }) => {

    return (<div className={className}>
        <div>
            <KeyboardArrowUpIcon className="closeButton" onClick={() => setOpen(false)} />
            <Link to={`/diamonds/${row._id}/details`}><img alt="" src={row.img} width={!isParcel ? 120 : 150} /></Link>
        </div>
        <div className="detailsSide">
            <h1 onClick={() => setOpen(false)}>
                {isParcel ? `${row.StkShape} PARCEL` : `${numeral(row.STWeight).format('0.00')} CT ${row.StkShape} DIAMOND`}
            </h1>
            <table onClick={() => setOpen(false)}>
                <tr>
                    <th>DETAILS</th>
                    <th></th>
                    {isAuthorised && <th>PRICE</th>}
                </tr>
                <tr>
                    <td><b>Code:</b> {row.StkCodeCalcNS || '-'}</td>

                    {!isParcel && <td><b>Certificate:</b> #{row.StkCertNo || '-'}</td>}
                    {isParcel && <Measurements row={row} />}

                    {isAuthorised && isParcel && <td><b>Price per carat:</b> {row.ppcOrig ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppcOrig, true, fxrates, ccy))).format('0,0.00')}</React.Fragment> : '-'}</td>}
                    {isAuthorised && !isParcel && <td><b>Price per carat:</b> {row.ppcOrig ? <React.Fragment>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.priceOrig, false, fxrates, ccy)) / parseFloat(row.STWeight)).format('0,0.00')}</React.Fragment> : '-'}</td>}
                    {!isAuthorised && <td><RegisterOrLoginToSeePriceNotice openEmailDialog={openEmailDialog} /></td>}
                </tr>
                <tr>
                    <td><b>Shape:</b> {row.StkShape || '-'}</td>

                    <td><b>Weight:</b> {!isParcel ? numeral(row.STWeight).format('0.00') + 'ct' : (row.size || '-')}</td>

                    {isAuthorised && !isParcel && <td><b>RAP Below:</b> {row.RAP ? row.RAP + '%' : '-'}</td>}
                    {isAuthorised && isParcel && <td>{row.WebSpecial && <React.Fragment><b>Special Price:</b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.WebSpecial, true, fxrates, ccy))).format('0,0.00')}</React.Fragment> || ''}</td>}
                </tr>
                <tr>
                    {!isParcel && <td><b>Clarity:</b> {row.clarity || '-'}</td>}
                    {isParcel && <td><b>Colour:</b> {row.colour || '-'}</td>}

                    {!isParcel && <td><b>Cut:</b> {row.cut || '-'}</td>}
                    {isParcel && <td><b>Sieve Plate:</b> {row.sieve || '-'}</td>}

                    {isAuthorised && !isParcel && <td><b>Price: </b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.priceOrig, false, fxrates, ccy))).format('0,0.00')}</td>}
                </tr>
                <tr>
                    {!isParcel && <td><b>Fluorescence:</b> {row.flourecence || '-'}</td>}
                    {isParcel && <td><b>Clarity:</b> {row.clarity || '-'}</td>}
                    {isParcel && <td><b>Comments:</b> {row.Comments || '-'}</td>}

                    {!isParcel && <td><b>Symmetry:</b> {row.symmetry || '-'}</td>}
                    {isAuthorised && !isParcel && <td>{row.WebSpecial && <React.Fragment><b>Special Price:</b> {getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00')}</React.Fragment>}</td>}
                </tr>
                <tr>
                    {!isParcel && <td><b>Colour:</b> {row.colour || '-'}</td>}
                    {!isParcel && <td><b>Polish:</b> {row.polish || '-'}</td>}

                    <td></td>
                </tr>
                <tr>
                    {!isParcel && <td><b>Table:</b> {row.StkTable ? row.StkTable + '%' : '-'}</td>}
                    {isParcel && <td></td>}

                    {!isParcel && isAuthorised && <td><b>RAP:</b> {row.RAP ? row.RAP + '%' : '-'}</td>}
                    {isParcel && <td></td>}

                    <td></td>
                </tr>
                <tr>
                    {!isParcel && <td><b>LAB:</b> {row.StkCertSup || '-'}</td>}
                    {isParcel && <td></td>}

                    {!isParcel && <Measurements row={row} />}
                    {isParcel && <td></td>}

                    <td></td>
                </tr>
            </table>

            <div className="callToActions">
                <div>
                    <div className="actionsLeft">
                        <div>
                            <Button
                                type="button"
                                variant="contained"
                                color="secondary"
                                onClick={() => props.openBag(row)}
                                disabled={!isAuthorised}
                            >
                                Add to Basket
                            </Button>
                        </div>
                        <div>
                            <Link to={`/diamonds/${row._id}/details`} className="noDecoration">
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="default"
                                >
                                    View Details
                                </Button>
                            </Link>
                        </div>
                    </div>
                    <div className="actionsLeft">
                        <div>
                            <Button
                                type="button"
                                variant="contained"
                                color="secondary"
                                onClick={(e) => { e.stopPropagation(); toggleCompare(!isCompare); }}
                            >
                                {isCompare ? 'Remove' : 'Add to'}  Compare
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="button"
                                variant="contained"
                                color="secondary"
                                onClick={(e) => { e.stopPropagation(); toggleFav(!isFav); }} 
                            >
                                {isFav ? 'Remove Favourite' : 'Add to Favourites'}
                            </Button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="actionsRight">
                        {!isParcel && <React.Fragment>
                            <div>
                                <div>
                                    <p>Report</p>
                                    <span>
                                        <Link to={`/diamonds/${row._id}/report`}>
                                            <img alt="" src="/images/certificate-icon-2.svg" />
                                        </Link>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>Diagram</p>
                                    <span>
                                        <Link to={`/diamonds/${row._id}/diagram`}>
                                            <img alt="" src="/images/diagram_active-2.svg" />
                                        </Link>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>Images</p>
                                    <span>
                                        <Link to={`/diamonds/${row._id}/details`}>
                                            <img alt="" src="/images/images.svg" />
                                        </Link>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <p>360</p>
                                    <span onClick={() => open360MessageDialog()} style={{ cursor: 'pointer' }}>
                                        <img alt="" src="/images/360.svg" />
                                    </span>
                                </div>
                            </div>
                        </React.Fragment>}
                    </div>
                </div>
            </div>

        </div>
    </div >)
})`
display: flex;
margin-top: -17px;
margin-left: -20px;
gap: 40px;

.noDecoration{
  text-decoration: none;
}

.closeButton{
    position: absolute;
    top: -20px;
    left: -10px;
    cursor: pointer;
    color: #b08f6e;
    width: 25px;
    height: 25px;
}

.detailsSide{
  flex: 1;

  h1{
    margin: 0;
    font-family: MinionPro-Disp;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 1.58px;
    text-align: left;
    color: #24272b;
    text-transform: uppercase;
  }

  table{  
    margin-top: 20px;
    width: calc(100% + 160px);
    margin-bottom: 10px;

    th{
      padding-bottom: 24px;
      font-family: Lato;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.25;
      letter-spacing: normal;
      text-align: left;
      color: #8d9298;
    }
    
    td{
      padding-bottom: 14px;
      font-family: Lato;
      font-size: 12px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: normal;
      text-align: left;
      font-weight: normal;
      color: #8d9298;

      white-space: nowrap; overflow: hidden; text-overflow:ellipsis;

      b{
        font-weight: bold;
        color: #484f57;
      }

      hr{
        height: 0;
        color: #313438;
      }
    }
  }

  .flexTable{
    display: flex;
    & > div{
      flex: 1;
    }
  }

  .callToActions{
    margin-bottom: 50px;
    width: calc(100% + 160px);
    display: flex;
    & > div{
      flex: 1;
    }

    .actionsLeft{
      display: flex;
      justify-content: flex-start;
      margin: -0.5em;

      & > div{
        margin: 0.5em;

        button {
          height: 33px;
          width: 130px;
          padding: 0;
          font-family: Lato;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.21;
          letter-spacing: normal;
          text-align: center;
          text-transform: none;
          color: #b08f6e;
          background-color: #ffffff;
          border: solid 1px #b6b8bc;
          box-shadow: none;
          display: block;
          margin: 0 auto;
          margin-bottom: 0px;
          margin-top: 16px;

          &:hover {
              background-color: inherit;
          }

          &.MuiButton-containedSecondary {
              color: #ffffff !important;
              border: solid 1px #b08f6e;
              background-color: #b08f6e;
          }

          &:disabled{
              border: solid 1px #ccced3;
              background-color: #ccced3;
          }
        }

      }
    }

    .actionsRight{
      display: flex;
      justify-content: flex-end;
      margin: -0.8em;

      & > div{
        margin: 0.8em;

        div{
          align-items: center;
          display: flex;
          flex-direction: column;

          p{
            font-family: Lato;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.25;
            letter-spacing: normal;
            text-align: center;
            color: #b08f6e;
            margin: 0;
            padding-bottom: 8px;
          }
          span{
            border: 1px solid #b08f6e;
            border-radius: 50%;
            width: 48px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
}
`;


const DiamondRowDetailsMobile = ({ isParcel, row, isAuthorised, ccy, fxrates = [], open360MessageDialog, openEmailDialog, setOpen, toggleCompare, isCompare, toggleFav, isFav, ...props }) => {
    return (<div className={stylesMobile.stylesMobile}>
        <h3>
            {isParcel ? `${row.StkShape} PARCEL` : `${numeral(row.STWeight).format('0.00')} CT ${row.StkShape} DIAMOND`}

            <IconButton size="small" onClick={() => setOpen(false)} className={stylesMobile.foldDiamondRow}>
                <KeyboardArrowUpIcon />
            </IconButton>
        </h3>
        <div className={stylesMobile.diamondImgWrap}>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleCompare(!isCompare); }} className={(!isCompare && stylesMobile.hoverSwitch) || undefined} style={{ paddingTop: 6 }}>
                {!isCompare && <React.Fragment>
                    <img alt="" src="/images/compare.svg" />
                    <img alt="" className={stylesMobile.hover} src="/images/compare_hover.svg" />
                </React.Fragment>}
                {isCompare && <img alt="" src="/images/compare_active.svg" />}
            </IconButton>
            <Link to={`/diamonds/${row._id}/details`}><img alt="" src={row.img} width={!isParcel ? 150 : 180} /></Link>
            <IconButton size="small" onClick={(e) => { e.stopPropagation(); toggleFav(!isFav); }} className={(!isFav && stylesMobile.hoverSwitch) || undefined}>
                {!isFav && <React.Fragment>
                    <img alt="" src="/images/fav.svg" />
                    <img alt="" className={stylesMobile.hover} src="/images/fav_hover.svg" />
                </React.Fragment>}
                {isFav && <img alt="" src="/images/fav_active.svg" />}
            </IconButton>
        </div>
        {isAuthorised && <div className={stylesMobile.price}>
            <div className={classNames(row.specialOffer && stylesMobile.specialOffer)}>
                {!isParcel && <span>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(convertToCurrency(row.price, false, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></span>}
                {isParcel && <span>{getSymbolFromCurrency(ccy)}{numeral(Math.round(convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00').split('.')[0]}.<small>{numeral(Math.round(convertToCurrency(row.ppc, true, fxrates, ccy))).format('0,0.00').split('.')[1]}</small></span>}
            </div>
        </div>}
        {!isAuthorised && <div className={stylesMobile.registerOrLoginToSeePricesNotice}><RegisterOrLoginToSeePriceNotice openEmailDialog={openEmailDialog} /></div>}
        <div className={stylesMobile.infoDetails}>
            {isParcel && <MeasurementsText row={row} />}
            {!isParcel && <ul>
                <li>{numeral(row.STWeight).format('0.00')}ct</li>
                <li>{row.colour || '-'}</li>
                <li>{row.clarity || '-'}</li>
            </ul>}
        </div>

        <DiamondDetailsList className={stylesMobile.diamondProperties} isParcel={isParcel} row={row} isAuthorised={isAuthorised} fxrates={fxrates} ccy={ccy} />

        <div className={stylesMobile.actions} style={{marginBottom: 10}}>
            <div>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={() => props.openBag(row)}
                    disabled={!isAuthorised}
                >
                    Add to Basket
                </Button>
            </div>
            <div>
                <Link to={`/diamonds/${row._id}/details`} className={stylesMobile.noDecoration}>
                    <Button
                        type="button"
                        variant="contained"
                        color="default"
                    >
                        View Details
                    </Button>
                </Link>
            </div>
        </div>
        <div className={stylesMobile.actions}>
            <div>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={(e) => { e.stopPropagation(); toggleCompare(!isCompare); }}
                >
                    {isCompare ? 'Remove' : 'Add to'}  Compare
                </Button>
            </div>
            <div>
                <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    onClick={(e) => { e.stopPropagation(); toggleFav(!isFav); }} 
                >
                    {isFav ? 'Remove Favourite' : 'Add to Favourites'}
                </Button>
            </div>
        </div>
    </div>)
};


const DiamondRowDetailsWrapper = (props) => {
    if (props.width === 'xs') {
        return <DiamondRowDetailsMobile {...props} />
    } else {
        return <DiamondRowDetails {...props} />
    }
}

export default withWidth()(DiamondRowDetailsWrapper);
